import React from "react";
import "./hero.scss";

import token1 from "../../assets/imgs/token-1.png";
import token2 from "../../assets/imgs/token-2.png";
import token3 from "../../assets/imgs/token-3.png";

import heroImg from "../../assets/imgs/Image_Hero.png";

const tokenList = [
    {
        id: 1,
        name: "Swap by Uniswap",
        img: token1,
        href: "https://app.uniswap.org/#/swap?use=v2&inputCurrency=ETH&outputCurrency=0xb31ef9e52d94d4120eb44fe1ddfde5b4654a6515&chain=mainnet",
    },
    {
        id: 2,
        name: "Swap by Uniswap",
        img: token2,
        href: "https://pancakeswap.finance/swap?outputCurrency=0x7837fd820bA38f95c54D6dAC4ca3751b81511357",
    },
    {
        id: 3,
        name: "Swap by Uniswap",
        img: token3,
        href: "https://app.apeswap.finance/swap?outputCurrency=0x7837fd820bA38f95c54D6dAC4ca3751b81511357",
    },
];

const Hero = () => {
    return (
        <section className=" hero">
            <div className="row">
                <div className="col l-7 m-8 c-12 hero__textBox_div ">
                    <div className="hero__textBox">
                        <h2 className="textBox__title">
                            Workout. Play. Rewards
                        </h2>

                        <p className="textBox__text">
                            DOSE is the token of purchase, utility and action
                            and is at the heart of the OliveX gamified fitness
                            ecosystem. Players will receive DOSE tokens for
                            completing workout based gameplay in Dustland
                            Runner, Dustland Rider, 22 Pushups and other
                            experiences.
                        </p>

                        <div className="btn btn__outline">
                            <i className="ri-send-plane-fill"></i>
                            <a
                                href="https://t.me/dose_community"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Join us on Telegram
                            </a>
                        </div>
                    </div>
                    <div className="btnToken">
                        <h4>Swap DOSE token:</h4>

                        {tokenList.map((item) => (
                            <div key={item.id} className="btn btn__fill__white">
                                <a href={item.href} rel="noreferrer">
                                    <div className="btnToken__item">
                                        <div className="left">
                                            <img
                                                className="left__img"
                                                src={item.img}
                                                alt="Swap by Uniswap"
                                            />
                                            <span className="left__name">
                                                {item.name}
                                            </span>
                                        </div>
                                        <div className="right">
                                            <i className="ri-arrow-right-line"></i>
                                        </div>
                                    </div>
                                    <div className="bg-hover"></div>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="col l-8 m-7 c-12 hero__img_div ">
                    <div className="hero__img">
                        <img src={heroImg} alt="hero" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
